var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapModal',{staticClass:"newModelPosition",attrs:{"modalNode":_vm.modalNode,"submitData":_vm.submitData,"submit":_vm.submit,"close":_vm.close,"title":_vm.simulationTitle,"id":"fixedRouteAddSpot"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }